import initialState from "./initialState";

export const types = {
  reset: "reset",
  SET_FILTER_REGISTRY: "SET_FILTER_REGISTRY",
  SET_FILTER_DATA: "SET_FILTER_DATA",
  SET_APPLIED_FILTERS: "SET_APPLIED_FILTERS",
  SET_LOCKED_FILTERS: "SET_LOCKED_FILTERS",
  SET_CUSTOM_FILTER_REGISTRY: "SET_CUSTOM_FILTER_REGISTRY",
};

export default {
  /**
   * Resets the module state with initial state
   */
  [types.reset]: state => {
    Object.keys(initialState()).forEach(key => {
      state[key] = initialState()[key];
    });
  },

  /**
   * Sets the list of filters to the filters registry
   */
  [types.SET_FILTER_REGISTRY]: (state, filters) => {
    state.filterRegistry = filters;
  },

  /**
   * Sets filters data to be displayed in the filterViewer
   */
  [types.SET_FILTER_DATA]: (state, filters) => {
    state.filterData = filters;
  },

  /**
   * Sets, the list of applied filters
   */
  [types.SET_APPLIED_FILTERS]: (state, filters) => {
    state.appliedFilters = filters;
  },

  /**
   * Sets the list of locked filters
   */
  [types.SET_LOCKED_FILTERS]: (state, filters) => {
    state.lockedFilters = filters;
  },

  /**
   * Sets the list of custome filters
   */
  [types.SET_CUSTOM_FILTER_REGISTRY]: (state, filters) => {
    state.customFilterRegistry = filters;
  },
};
